"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityCategory2d = void 0;
const core_1 = require("@visualization-tools/core");
/**
 * @public
 * Update category for 2d plots. Provides Z-ordering.
 */
class EntityCategory2d extends core_1.EntityCategory {
    constructor(plot, renderer, updateGroup, updateHooks) {
        super(plot, renderer, updateGroup, updateHooks);
        this.entityZIndexRange = 0;
        this.zIndex = EntityCategory2d.counter++; // todo jack26: actually set these
        updateGroup.categories.addCategory(this);
    }
}
exports.EntityCategory2d = EntityCategory2d;
EntityCategory2d.counter = 0;
//# sourceMappingURL=entity-category2d.js.map